import { render, staticRenderFns } from "./schemaSequence.vue?vue&type=template&id=20e2aef2&scoped=true"
import script from "./schemaSequence.vue?vue&type=script&lang=js"
export * from "./schemaSequence.vue?vue&type=script&lang=js"
import style0 from "./schemaSequence.vue?vue&type=style&index=0&id=20e2aef2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e2aef2",
  null
  
)

export default component.exports